module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMCAYAAAC9QufkAAABFElEQVQokZXSPWtUURDG8d/dvbuERF1r+7TJBwikOo2lkC9gJdtJwD5in+0DaULyKWYKwZfKxpSi2KVLYdZEFC/XYu/CEhPYfWA4h4Fn5sx/ThURL1Dwx/Ia4kONp9jHBXpLGFuMMKlxhe+llHaFzr8y87KHCvUKxrmqKiLe4j1uVjAOsFOjwQ/8NZtnUQ2usdEVX+tyFRoRcdy2rfsiIkbdOVzIPYyISRURpxiXUqa335aZz7CHQ7zCAcb4gs35av4jnZmbeIPPeG62yl1s4x3aubm5A8oTnOIEXzEx+wevSynnGNRYx6PM/H3L/AkfO5BHpZSbzDwrpUwzcwOPq4h4iS387Cgukm7R7+79rlAPD/DtHwAJeDbBBXqQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/33.png
// module id = q46X
// module chunks = 0